export const toPercentage = (arrayOfNumbers, indexOfNumber) => {
  const sum = arrayOfNumbers.reduce((acc, cur) => {
    return acc + cur
  })
  return Math.round((arrayOfNumbers[indexOfNumber] * 100) / sum)
}
